export default __webpack_public_path__ + "static/media/icono4gris.eb82388e.svg";